export default __webpack_public_path__ + "img/6ce75f0a9bbfb064df6bd71c30de66aa.jpg";